import {
  maxLength10,
  maxLength6,
  maxLength4,
  required,
  noDigits,
  number,
  trimError,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  onlyDigits,
  onlyLettersAndNumberAndHyphen,
  maxLength80,
  maxLength50,
  onlyLetters,
  trimNoSpecStartOrEnd,
  onlyHouse,
} from '../utils/validation';
import DTO from './DTO';

class InformationDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'in_request_inf.date_time',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'in_request_inf.status',
      },
      {
        name: 'inf_type',
        type: String,
        validators: {},
        labelKey: 'in_request_inf.inf_type',
      },
      {
        name: 'api_id',
        type: String,
        validators: {},
        labelKey: 'in_request_inf.api_id',
      },
      {
        name: 'inf_size',
        type: String,
        validators: {},
        labelKey: 'in_request_inf.inf_size',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default InformationDTO;
